export const borders = {
    borderRadiusExtraSmall: 4,
    borderRadiusSmall: 8,
    borderRadiusNormal: 10,
    borderRadiusLarge: 12,
} as const;
